import {DEVICE_DATA_COLLECTION_COMPLETE} from '../action-types';

export default () => ({
  type: DEVICE_DATA_COLLECTION_COMPLETE,
});
